import { types } from "../types/types";
import { fetchConToken } from "../helpers/fetch";
import { startSpinner, finishSpinner } from "./ui/spinner";
import { handleErrorApi } from "../helpers/randoms";
import { startAlerta } from "./ui/alertas";

export const bandejaTraerStart = () => ({ type: types.bandejaTraerStart });
export const bandejaLimpiar = () => ({ type: types.bandejaLimpiar });
export const bandejaTraerError = (error) => ({ type: types.bandejaTraerError,payload: error});
export const bandejaTraerSuccess = (payload) => {
    return {
        type: types.bandejaTraerSuccess,
        payload: payload
    }
}
export const bandejaTraerCantidades = (payload) => {
    return {
        type: types.bandejaTraerCantidades,
        payload: payload
    }
}

export const fetchCantidadesBandeja = (idArea, idSeccional) => {
    return async (dispatch) => {
        dispatch(bandejaTraerStart());
        dispatch(startSpinner());
        try {
            const result = await fetchConToken(`bandejasPreafiliacion/traerContadoresXArea/${idArea}/${idSeccional}` );
            const body = await result.json();
            if (!result.ok) {
              throw body;
            };
            dispatch(bandejaTraerCantidades(body));
          } catch (error) {
            handleErrorApi(
              dispatch,
              error,
              "Error al traer los Contadores.",
              "Ha ocurrido un error. Intente nuevamente"
            );
          }
          dispatch(finishSpinner());
    };
};
  
export const fetchBandejaBusqueda = (idArea, idSeccional, busquedaStr) => {
    return async (dispatch) => {
        dispatch(bandejaTraerStart());
        dispatch(startSpinner());
        const response = await fetchConToken(`bandejasPreafiliacion/traerPreafiliadosXAreaXString/${idArea}/${idSeccional}/${busquedaStr}`);
        if (!response.ok) {
            dispatch(bandejaTraerError(response.statusText));
            throw Error(response.statusText);
        }
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
            const lista = await response.json();
            console.log( lista );
            // if (lista.length>0) {
                dispatch(bandejaTraerSuccess(lista));
            // }
        }
        dispatch(finishSpinner());
    };
};

export const fetchBandejaEliminar = (idPreafiliado) => {
    return async (dispatch) => {
        dispatch(startSpinner());
        try{
            const response = await fetchConToken(`bandejasPreafiliacion/eliminarPreafiliadosEnCarga/${idPreafiliado}`, "", "DELETE");
            const lista = await response.json();
            if (!response.ok) {
                dispatch(bandejaTraerError(response.statusText));
                throw Error(response.statusText);
            }
            
            dispatch(bandejaTraerSuccess(lista));
            dispatch(startAlerta("Afiliado eliminado", "success", "Aviso"));
        } catch(error) {
            handleErrorApi(
                dispatch,
                error,
                "Error al eliminar el Preafiliado.",
                "Ha ocurrido un error. Intente nuevamente"
            );
        }
        dispatch(finishSpinner());
    };
}

export const fetchBandejaPorEstados = (data,idSeccional,idAera) => {
    return async (dispatch) => {
        dispatch(bandejaTraerStart());
        dispatch(startSpinner());
        const response = await fetchConToken(`bandejasPreafiliacion/traerPreafiliadosXEstados/${data}/${idSeccional}/${idAera}`);
        if (!response.ok) {
            dispatch(bandejaTraerError(response.statusText));
            throw Error(response.statusText);
        }
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
            const lista = await response.json();
            dispatch(bandejaTraerSuccess(lista));
        }
        dispatch(finishSpinner());
    };
};
export const fetchBandejaPorEstado = (idArea, idEstado, idSeccional) => {
    return async (dispatch) => {
        dispatch(bandejaTraerStart());
        dispatch(startSpinner());
        try {
            const result = await fetchConToken(`bandejasPreafiliacion/traerPreafiliadosXAreaXEstado/${idArea}/${idEstado}/${idSeccional}`);
            const body = await result.json();
            if (!result.ok) {
              throw body;
            };
            dispatch(bandejaTraerSuccess(body));
          } catch (error) {
            handleErrorApi(
              dispatch,
              error,
              "Error al traer las afiliados en bandeja.",
              "Ha ocurrido un error. Intente nuevamente"
            );
          }
          dispatch(finishSpinner());
    };
};

export const contadoresFitrado = (contadoresSerializados) => {
    return async (dispatch, getState) => {
      const state = getState();
      const { areas, idSeccional } = state.auth;
      const contadores = JSON.parse(contadoresSerializados);
      const areasIds = areas.map( s => s.idArea);

      const groupByIdEstado = () => {
        const result = [];
        contadores.reduce( (res, value) => {
            if (!res[value.idEstado]) {
                res[value.idEstado] = { idEstado: value.idEstado, total: 0 };
                result.push(res[value.idEstado])
            }
            res[value.idEstado].total += value.total;
            return res;
        }, {});
        return result;
      }

      const contadoresFiltrados = areasIds.includes(1) ? contadores.filter( s => s.idSec === idSeccional) : groupByIdEstado();
      dispatch( bandejaTraerCantidades(contadoresFiltrados) );
    };
  };
  
